import { BailleursParticipantSex } from '../types/bailleurs-participant';
export const personSexOptions = [
    { value: BailleursParticipantSex.MALE, label: 'bailleurs.core.person.form.option.sex.male' },
    { value: BailleursParticipantSex.FEMALE, label: 'bailleurs.core.person.form.option.sex.female' },
];
